import * as moment from "moment";
import { ISwabShipmentBatch, useSwabShipmentBatchApi } from "@nkr/models/hla/swab-shipment-batch";
import { SwabShipmentBatchAccordion } from "../page-components/swab-shipment-batch-accordion";

export const SwabShipments = () => {
    var batchApi  = useSwabShipmentBatchApi();
    var response  = batchApi.useGetAll();


    return (
        <div className="container">
            <div className="row">
                <div className="col-xs-12">
                    <h1 style={{ margin: 0 }}>Swab Shipment Batches</h1>
                    <br />
                    <div className="well">
                        <div className="row">
                            <div className="col-xs-12">
                                
                            {!response?.isSuccess || !response?.payload ? <div>Loading...</div> : (
                                response.payload?.map((batch: ISwabShipmentBatch) => {
                                    return <SwabShipmentBatchAccordion batch={batch} />;
                                })
                            )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};